





































import Vue from "vue";
import Vuex from "vuex";
import { Component, Prop } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import DataTableComponents from "@/components/App/Assets/Card/Body/CardType/DataTable/SimpleDataTable.vue";
import { http } from "@/shared/https";
import { Workspace, ApplicationSubmit } from "@/entities";

const namespace: string = "application";

/*
 * Component's properties and events
 */
@Component({
  components: {
    DataTableComponents,
  },
})
export default class ApplicationTableListComponent extends Vue {
  @State(namespace) application!: Workspace;
  @Action("getApplication", { namespace }) getApplication: any;
  @Action("resetAppState", { namespace }) resetAppState: any;
  @Action("setApplicationId", { namespace }) setApplication: any;
  @Getter("rootTemplate", { namespace }) schema: any;
  @Getter("_appUser", { namespace: "RootApp" }) _username!: string;
  @Getter("projectYrs", { namespace: "application" }) years: any;
  @Getter("reportingFrequency", { namespace: "application" }) reportingFreq: any;
  @Getter("appSubmit", { namespace }) appSubmit: ApplicationSubmit;

  appStatus: any = _app.applicationStatus;
  editableStatus: any = _app.applicantEdiatableStatus;

  @Prop() calls!: any;
  uploadReady: boolean = true;
  filterByKey = "";

  // data() {
  //   let payload = this.$store.state["applicationIndex"];
  //   payload.orgFields = payload.fields;
  //   payload.data = this.calls;
  //   return payload;
  // }

  get appItems() {
    return this.calls;
  }

  /*** data table options  */
  get options() {
    return {
      accessRights: this.checkBtnRights
    }
  }

  mounted() {
    let rootState = this.$store.state;
    let payload = this.$store.state.dashboard;
    let componentName = "applicationIndex";

    let header = [],
      totalFields,
      fieldsList = [];

    //#.Filter component enabled.
    if (payload.template.filter == true) {
      payload.cards.push("FilterComponent");
      payload.title.push("Filter");
    }

    // @ts-ignore
    _.forOwn(rootState[componentName].fields, function (key, val) {
      if (
        key.primaryKey != true &&
        key.parent != true &&
        key.list != false &&
        key.type != "Hidden"
      ) {
        if (!key.orgTitle) key.orgTitle = key.title;

        if (payload.keyTranslator) key.text = key.orgTitle;
        else key.text = key.title;

        key.title = key.text;
        // @ts-ignore
        header.push(key);
      }

      if (
        !key.primaryKey &&
        key.type != "Hidden" &&
        !key.create &&
        !key.parent
      ) {
        // @ts-ignore
        fieldsList.push(key.value);
      }
    });

    rootState[componentName].headers = header;

    // this.callProposalCallFilter("");

    // @ts-ignore
    this.$store.dispatch("load", this.$store.state["applicationIndex"]);
  }

  /*callProposalCallFilter*/
  callProposalCallFilter(e) {
    var self = this;
    http.get(`/api/AdminDashboard?${e}`).then((resp: any) => {
      this.uploadReady = false;
      this.$nextTick(() => {
        this.uploadReady = true;
      });
      self.calls = resp.data.Items;
    });
  }

  editApplication(data) {
    var self = this;
    this.resetAppState();
    this.setApplication(data.ApplicationId);
    this.$router.push({
      name: "applicationSummary",
      params: { applicationId: data.ApplicationId }
    });
  }

  /** Delete Proposal*/
  deleteApplication(data) {
    let self = this;
    const id = data.ApplicationId;
    if (confirm("Are you sure to delete this application?")) {
      this.$services.application.deleteApplication(id).then((data: any) => {
        if (data.Result === "OK") {
          this.callProposalCallFilter("");
        }
      });
    }
  }

  downloadApplication(data) {    
    let self = this;
    const appId = data.ApplicationId;
    this.getApplication(appId).then((data: any) => {
      if (data && data.projectTitle) {
        this.generatePdf();
      }
    });
  }

  /** method to generate the pdf file */
  generatePdf() {
    // const applicationData =this.application.application.BudgetType == 'Tiger' ? { ...this.application.data, amountOfMatchingFund:  this.application.data.applicationBudget.summary.totalBudget.matchFunding || 0 } : this.application.data;
     let applicationData;

switch (this.application.application.BudgetType) {
  case 'Tiger':
    applicationData = {
      ...this.application.data,
      amountOfMatchingFund: this.application.data.applicationBudget.summary.totalBudget.matchFunding || 0
    };
    break;
  case 'CAG':
    applicationData = {
      ...this.application.data,
      fundingRequests: this.application.data.totalProjectBudgect || 0
    };
    break;
  default:
    applicationData = this.application.data;
    break;
}
    this.$services.pdf.generate({
      entity: "Application",
      schema: this.schema,
      data: applicationData,
      currency: this.application.application.BudgetCurrency,
      user: this._username,
      id: this.application.application.ApplicationId,
      type: this.application.templates["IsRAGTemplate"] ? "RAG" : "TSG",
      code: this.application.application.Code,
      "years":this.years,
      "Quaters":this.reportingFreq,
      "checklist": this.appSubmit.checklist,
      "logSchema": this.application.logSchema
    });
  }

    /** check the button rights */
  checkBtnRights(field: any, record: any) {
    switch(field.event) {
      case 'delete':
        return _app.workflowStatusCode.draft.includes(record.StatusCode) || record.StatusId== this.appStatus.draft || record.StatusId==this.appStatus.RAGdraft;
        break;
        
      default:
        return true;
    }
  }
}
